import * as angular from 'angular';
import mediaQueryFactory from './media-query.factory';

require('angular-media-queries');

export default angular
  .module('MediaQueryModule', [
    'matchMedia',
  ])
  .factory('MediaQueryService', mediaQueryFactory)
  /* @ngInject */
  .run((MediaQueryService) => {
    MediaQueryService.rules = {
      tablet: '(min-width: 768px) and (max-width: 1023px)',
      desktop: '(min-width: 1024px)',
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/shared/media-query/media-query.module.js